import { Observable, Subject, BehaviorSubject, of, throwError } from 'rxjs';
import { Component, EventEmitter, Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';




import { ProjectItem } from './project/index';
import { AuthService, IUserInfo } from './shared/core/index';
import { ILookup, LookupList } from './shared/lookup';
import { CISignedUrl, CIAsset } from './clearance-item/clearance-item.model';
import { HttpService } from './shared/core/http.service';

import * as _ from 'lodash';
import { map, tap, catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

//declare var apiSessionId: any;
//
@Injectable()
export class AppService {    
    public listViewURL: string;
    private userPrefUrl = new URL('userprefs', this._authService.API_URL).toString();
    private searchAPIUrl = new URL('search', this._authService.API_URL).toString();
    private awsServiceAPIUrl = new URL('aws/sign', this._authService.API_URL).toString();
    private lookupsAPIUrl = new URL('lookups', this._authService.API_URL).toString();
    private emailServiceAPIUrl = new URL('email', this._authService.API_URL).toString();
    public scrollBottomReachedEvent: EventEmitter<void> = new EventEmitter<void>();
    private _isProjectLoaded: boolean = true;
    private _isDownloadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    downloadingObservable = this._isDownloadingSubject.asObservable();
    downloadQueue: string[] = [];
    private _projectHeaderUpdateSubject = new Subject<{ projectId: string, projectName: string }>();
    public projectHeaderUpdate = this._projectHeaderUpdateSubject.asObservable();
    private _displayNameSubject = new Subject<string>();
    public displayNameUpdate = this._displayNameSubject.asObservable();

    constructor(private _http: HttpClient, private _authService: AuthService, private _httpService: HttpService, private ngZone: NgZone) {

    }
    getUserPreferences(): Observable<ProjectItem[]> {

        console.log('AppService.getUserPreferences()...');
        let userRoles = this._authService.userRoles; 
        //return this._http.get(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=&isDashboard=false', { headers })
        return this._httpService.httpGet(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=&isDashboard=false', userRoles).pipe(
            map((response) => {
                // console.log('AppService.getUserPreferences() >> projects:' + JSON.stringify(response));
                return response as any;
            })
        );

        // .catch(this.handleError);
    }

    getDashboardProject(projectId: string): Observable<ProjectItem[]> {
        
        let userRoles = this._authService.userRoles; 
        console.log('AppService.getDashboardProject(' + projectId + ')...');
        return this._httpService.httpGet(
        this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=' + projectId + '&isDashboard=true', userRoles).pipe(
            map((response) => {
                return this.toProject(response);
            }),
            tap(data => data),
            catchError(this.handleError)
        );
    }

    toProject(r: any): ProjectItem[] {

        // console.log('r:' + JSON.stringify(r));

        if (!r) return [];

        // Normalize: if response is a single object, wrap in array
        const items = Array.isArray(r) ? r : [r];

        let retProjects = new Array<ProjectItem>();

        items.forEach(element => {
            let p = <ProjectItem>element;

            //process 'PENDINGS' - only aggregate counts if CICount is available
            if (p.CICount) {
                p.AdPubCICount = this.aggregateByStatus(p.CICount, 'RESTR_Ad/Pub');
                p.ArtCICount = this.aggregateByStatus(p.CICount, 'TAG_Art Department');
                p.PropsCICount = this.aggregateByStatus(p.CICount, 'TAG_Props');
                p.SetDecCICount = this.aggregateByStatus(p.CICount, 'TAG_Set Dressing');
                p.WardrobeCICount = this.aggregateByStatus(p.CICount, 'TAG_Wardrobe');
                p.PostCICount = this.aggregateByStatus(p.CICount, 'TAG_Post');
                p.ScriptCICount = this.aggregateByStatus(p.CICount, 'TAG_Script');
                p.LocationCICount = this.aggregateByStatus(p.CICount, 'TAG_Location');
                p.ResearchCICount = this.aggregateByStatus(p.CICount, 'TAG_Research');
                p.EndCreditCICount = this.aggregateByStatus(p.CICount, 'RESTR_End credit');
                p.StatusChangeCICount = this.aggregateByStatus(p.CICount, 'CHGSTATUS');
                p.ClipCICount = this.aggregateByStatus(p.CICount, 'TAG_Clip');
                p.MaterialReleaseCICount = this.aggregateByStatus(p.CICount, 'TAG_Material Release');
                p.ArtistCertificateCICount = this.aggregateByStatus(p.CICount, 'TAG_Artist Certificate');
                p.PhotoReleaseCICount = this.aggregateByStatus(p.CICount, 'TAG_Photo Release');
                p.ProductPlacementCICount = this.aggregateByStatus(p.CICount, 'TAG_Product Placement');
                p.MainCharacterCICount = this.aggregateByStatus(p.CICount, 'TAG_Character - Main');
                p.SecondaryCharacterCICount = this.aggregateByStatus(p.CICount, 'TAG_Character - Secondary');
                p.IncidentalCharacterCICount = this.aggregateByStatus(p.CICount, 'TAG_Character - Incidental');
                p.EffectsCICount = this.aggregateByStatus(p.CICount, 'TAG_Effect');
                p.CrowdCICount = this.aggregateByStatus(p.CICount, 'TAG_Crowd');
                p.MouthChartCICount = this.aggregateByStatus(p.CICount, 'TAG_Mouth Chart');
                p.SpecialPoseCICount = this.aggregateByStatus(p.CICount, 'TAG_Special Pose');
                p.SizeCompCICount = this.aggregateByStatus(p.CICount, 'TAG_Size Comp');
                p.CLRCount = this.aggregateByStatus(p.CICount, 'TAG_CLR');
                p.DigimatteCount = this.aggregateByStatus(p.CICount, 'TAG_Digimatte');
                p.GraphicCount = this.aggregateByStatus(p.CICount, 'TAG_Graphic');
                p.NotesCount = this.aggregateByStatus(p.CICount, 'NOTES');
            }
            p.ContactTitle = p.ContactTitle;
            p.ContactName = p.ContactName;
            p.ContactEmail = p.ContactEmail;
            p.ContactPhoneNumber = p.ContactPhoneNumber;

            retProjects.push(p);
        });

        return retProjects;
    }

    private aggregateByStatus(ciCounts: Map<string, number>, statusOrKey: string): number {

        if (!ciCounts) return 0;

        var myKeys = Object.keys(ciCounts);

        var matchingKeys = myKeys.filter(function (key) { return key.indexOf(statusOrKey) !== -1 });

        let retValue: number = 0;

        matchingKeys.forEach(k => {
            retValue += ciCounts[k];
        }
        );

        return retValue;
    }

    private aggregateByStatusStart(ciCounts: Map<string, number>, statusOrKey: string): number {
    if (!ciCounts) return 0;

    var myKeys = Object.keys(ciCounts);

    var matchingKeys = myKeys.filter(function (key) { 
        return key.startsWith(statusOrKey); 
    });

    let retValue: number = 0;

    matchingKeys.forEach(k => {
        retValue += ciCounts[k];
    });

    return retValue;
}

    addFavorite(project: ProjectItem): Observable<Boolean> {

        project.PreferenceType = 'Favorite Project';
        return this._httpService.httpPost(this.userPrefUrl, project, this._authService.userRoles).pipe(
            map(() => true),
            tap(data => data)
        );
    }

    addRecent(project: ProjectItem): Observable<ProjectItem> {

        
        let userRoles = this._authService.userRoles; 
        project.PreferenceType = 'Recent Project';
        project.SortOrder =1;
        project.UserId = this._authService.userInfo.userId;
        var body = JSON.stringify(project);
        return this._httpService.httpPost(this.userPrefUrl, project, userRoles).pipe(
            map((response) => response as any),
            tap(data => data)
        );
    }

    deleteFavorite(project: ProjectItem): Observable<Boolean> {

        return this._httpService.httpDelete(this.userPrefUrl + '?userId=' + this._authService.userInfo.userId + '&projectId=' + project.ProjectId).pipe(
            map(() => true),
            tap(data => data),
            catchError((error) => {
                // Empty 200/204 body fails default JSON parsing; the delete still succeeded.
                if (error && (error.status === 200 || error.status === 204)) {
                    return of(true);
                }
                return this.handleError(error);
            })
        );
    }

    search(terms: Observable<string>, isExactMatch = false, debounceDuration = 100): Observable<ProjectItem[]> {
        return terms.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(term => this.rawSearch(isExactMatch, term)),
            catchError((e) => {
                console.error('error on AppService.search(): ' + JSON.stringify(e));
                return of<any>([]);
            })
        );
    }

    rawSearch(isExactMatch: boolean, term: string, searchByCode: boolean = false): Observable<ProjectItem[]> {

        return this._httpService.httpGet(this.searchAPIUrl + '?projectName=' + encodeURI(term) + '&exactMatch=' + isExactMatch.toString() + '&byCode=' + searchByCode).pipe(
            map((response) => {
                var result = response as any;
                return result;
            }
            ),
            tap(data => data),
            catchError(this.handleError)
        );
    }

    private ciLookups: LookupList[];

    retrieveCILookups(lookups: string = 'CIStatus,Tags,CIRestrictions', projectId: string = '', forceRefresh: boolean = false): Observable<LookupList[]> {
        ;
        // console.log('AppService.retrieveCILookups()');

        let requestedLookups = lookups.split(',');

        if (!projectId && !forceRefresh && this.ciLookups != null && this.ciLookups.length > 0 && _.difference(requestedLookups, Array.prototype.map.call(this.ciLookups, s => s.lookupType)).length === 0) {
            return of(this.ciLookups);
        }
        else {
            return this._httpService.httpGet(this.lookupsAPIUrl + '?lookupTypes=' + lookups+'&projectId=' + projectId).pipe(
                map((response: any) => {
                    this.ciLookups = <LookupList[]>response;
                    return this.ciLookups;

                })
            );
        }

    }
    downloadReport(projectId: string): Observable<Blob> {
        var url = "http://adsscrimsjsreport-env.2cjezmpdiu.us-west-1.elasticbeanstalk.com/api/report";
        var body = { "template": { "shortid": "BkVlg9wd-" }, "data": { "projectId": projectId } };
        return new Observable<Blob>(subscriber => {
            return this._http.post(url, body, { responseType: 'blob' }).pipe(
                map(
                    (res) => {
                        return new Blob([res], { type: 'application/pdf' })
                    }),
                tap(data => data),
                catchError(this.handleError)
            ).subscribe({
                next: (value) => this.ngZone.run(() => subscriber.next(value)),
                error: (err) => this.ngZone.run(() => subscriber.error(err)),
                complete: () => this.ngZone.run(() => subscriber.complete())
            });
        });
    }

    private handleError(error) {

        console.log('AppService.handleError() >> error:' + error);
        return throwError(() => error || 'Server error');
    }

    getSignedUrl(file: string, project: string, method: string, type: string, ownerType: string, name: String): Observable<CISignedUrl> {
        
        let paramName ='';
        if (name != ''){
            paramName = '&n=' + name;
        }
        console.log('ClearanceItemService.getSignedUrl >> Url: ' + this.awsServiceAPIUrl + '?f=' + file + '&p=' + project + '&o=' + ownerType + paramName);

        return this._httpService.httpGet(this.awsServiceAPIUrl + '?f=' + file + '&p=' + project + '&m=' + method + '&t=' + type + '&o=' + ownerType + paramName).pipe(
            map((response) => response as any),
            tap(data => data),
            catchError(this.handleError)
        );
    }

    getSignedUrlInline(file: string, project: string, method: string, type: string, ownerType: string, name: String): Observable<CISignedUrl> {
        let paramName ='';
        if (name != ''){
            paramName = '&n=' + name;
        }
        console.log('ClearanceItemService.getSignedUrlInline >> Url: ' + this.awsServiceAPIUrl + '?f=' + file + '&p=' + project + '&o=' + ownerType + paramName);
        return this._httpService.httpGet(this.awsServiceAPIUrl+'/inline' + '?f=' + file + '&p=' + project + '&m=' + method + '&t=' + type + '&o=' + ownerType + paramName).pipe(
            map((response) => response as any),
            tap(data => data),
            catchError(this.handleError)
        );
    }

    getFileAs(file: CIAsset): Observable<Blob> {

        return new Observable<Blob>(subscriber => {
            return this._http.get(file.fullUrl, { responseType: 'blob' }).pipe(
                map((response) => {
                    return new Blob([response], { type: file.fileType })
                }),
                catchError(this.handleError)
            ).subscribe({
                next: (value) => this.ngZone.run(() => subscriber.next(value)),
                error: (err) => this.ngZone.run(() => subscriber.error(err)),
                complete: () => this.ngZone.run(() => subscriber.complete())
            });
        });
    }

    sendNewUserEmail(email: string): Observable<boolean> {
        console.log('EmailService.SendNewUserEmail >> Url: ' + this.emailServiceAPIUrl + '/newuser?email=' + email);
        return this._httpService.httpGet(this.emailServiceAPIUrl + '/newuser?email=' + email).pipe(
            map((response) => response as any),
            catchError(this.handleError)
        );
    }

    getReferenceDocuments(projectId: string): Observable<any[]> {
        let file='.';
        let method = 'GET';
        let type = 'ref';
        let ownerType = 'ref';
        let name = ''
        let paramName ='';
        if (name != ''){
            paramName = '&n=' + name;
        }
        console.log('ClearanceItemService.getSignedUrl >> Url: ' + this.awsServiceAPIUrl+'/helpdocsreference' + '?f=' + file + '&p=' + projectId + '&o=' + ownerType + paramName);

        return this._httpService.httpGet(this.awsServiceAPIUrl+'/helpdocsreference' + '?f=' + file + '&p=' + projectId + '&m=' + method + '&t=' + type + '&o=' + ownerType + paramName).pipe(
            map((response) => response as any),
            tap(data => data),
            catchError(this.handleError)
        );
    }

    get isProjectLoaded():boolean{
        return this._isProjectLoaded;
    }

    set isProjectLoaded(value : boolean){
        this._isProjectLoaded = value;
    }
    
    get isDownloading():boolean{
        return this.downloadQueue.length>0
    }

    enqueueDownload(filename: string){
        this.downloadQueue.push(filename);
        this._isDownloadingSubject.next(true);
        
    }

    removeFromDownloadQueue(fileName){
        let i = this.downloadQueue.indexOf(fileName);
        if (i !== -1) {
            this.downloadQueue.splice(i, 1);
        }
        this._isDownloadingSubject.next(this.downloadQueue.length>0);
    }

    get downloadFileNames():string[]{
        return this.downloadQueue;
    }

    updateProjectHeader(projectId: string, projectName: string){
        this._projectHeaderUpdateSubject.next({ projectId, projectName });
    }

    updateDisplayName(name: string){
        this._displayNameSubject.next(name);
    }
}

